/*
 *    Copyright [2007-2025] [wisemapping]
 *
 *   Licensed under WiseMapping Public License, Version 1.0 (the "License").
 *   It is basically the Apache License, Version 2.0 (the "License") plus the
 *   "powered by wisemapping" text requirement on every single page;
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the license at
 *
 *       https://github.com/wisemapping/wisemapping-open-source/blob/main/LICENSE.md
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

const ZH = {
  LOADING: '加载......',
  SAVING: '保存......',
  SAVE_COMPLETE: '保存完成',
  ZOOM_IN_ERROR: '放大比例过高。',
  ZOOM_ERROR: '无法再缩放了。',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED: '无法创建主题。只能选择一个主题。',
  ONE_TOPIC_MUST_BE_SELECTED: '无法创建主题。必须选择一个主题。',
  ONLY_ONE_TOPIC_MUST_BE_SELECTED_COLLAPSE: '无法折叠子节点，必须只选择一个主题。',
  SAVE_COULD_NOT_BE_COMPLETED: '无法完成保存，请稍后再试。',
  UNEXPECTED_ERROR_LOADING: '我们很抱歉，发生了意外错误。\n再次尝试重新加载编辑器。如果问题仍然存在，请联系我们support@wisemapping.com。',
  MAIN_TOPIC: '重点主题',
  SUB_TOPIC: '子主题',
  ISOLATED_TOPIC: '独立主题',
  CENTRAL_TOPIC: '中心主题',
  ENTITIES_COULD_NOT_BE_DELETED: '无法删除主题或关系。至少选择一个脑图实体。',
  CLIPBOARD_IS_EMPTY: '没有东西可以复制。剪贴板是空的。',
  CENTRAL_TOPIC_CAN_NOT_BE_DELETED: '无法删除中心主题。',
  RELATIONSHIP_COULD_NOT_BE_CREATED: '无法创建关系。必须先选择要建立关系的主题。',
  SESSION_EXPIRED: '您的会话已过期，请重新登录。',
};

export default ZH;
